import "vite/modulepreload-polyfill";
import "./assets/styles/index.scss";

import ReactDOM from "react-dom/client";

import Main from "./Main.jsx";

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(Main());
